import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { registerUser, createUserDefaults, createUserS3Folders } from '../slices/userSlice';
import { switchActiveRole } from '../slices/userRoleSlice';
import { Button, Input, Dropdown, Message } from "semantic-ui-react"
import useRoleNormalization from '../hooks/useRoleNormalization';

function RegistrationForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Initialize role normalization hook
  const { getRoleSelectionOptions } = useRoleNormalization();

  // Clear any existing auth token when the registration page loads
  React.useEffect(() => {
    localStorage.removeItem('authToken');
  }, []);

  const userProfile = useSelector((state) => {
    return state.user.profile
  });

  const [title, setUserTitle] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [role, setRole] = useState(''); // No default role, user must select
  const [formError, setFormError] = useState('');

  // Role options from the hook (uses normalized format)
  const roleOptions = getRoleSelectionOptions();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Clear previous errors
    setFormError('');

    // Validate form fields
    if (!title.trim()) {
      setFormError('User Title is required');
      return;
    }

    if (!email.trim()) {
      setFormError('Email is required');
      return;
    }

    if (!phone.trim()) {
      setFormError('Phone is required');
      return;
    }

    if (!password.trim()) {
      setFormError('Password is required');
      return;
    }

    if (!passwordConfirm.trim()) {
      setFormError('Password confirmation is required');
      return;
    }

    // Validate role selection
    if (!role) {
      setFormError('Please select a role');
      return;
    }

    // Check if passwords match
    if (password !== passwordConfirm) {
      setFormError('Passwords do not match');
      return;
    }

    try {
      // Save the normalized role value to user node on Neo4js
      const backendRole = role;

      // creates and returns the user's uuid foldername (userId)
      // for use creating defaults and S3Folders
      let loginResults = await dispatch(registerUser({
        title,
        email,
        phone,
        password,
        role: backendRole  // Send in backend format
      })).unwrap();
      console.log('loginResults', loginResults)
      if (loginResults.token && loginResults.token.length > 10) {
        localStorage.setItem('authToken', loginResults.token);

        // Set the active role in Redux store (use normalized format)
        dispatch(switchActiveRole(role));

        await dispatch(createUserDefaults({ userId: loginResults.userId, email })).unwrap();
        await dispatch(createUserS3Folders({ userId: loginResults.userId, email })).unwrap();
        navigate('/landingPage');
      }
    }
    catch (error) {
      console.error('Registration failed:', error);
      setFormError(error.toString());
    }
  };

  return (
    <div className='regLoginContainer'>
      <span className='formHeading'>Register</span>
      <br />
      <form onSubmit={handleSubmit} style={{ marginTop: "30px" }}>
        <span className='inputLabel'>User Title:</span>
        <Input
          className='inputWidthMedium marginBottom_10'
          placeholder="User Title"
          type="text"
          id="title"
          value={title}
          onChange={(e) => setUserTitle(e.target.value)}
        />
        <br />
        <span className='inputLabel'>Email:</span>
        <Input
          className='inputWidthMedium marginBottom_10'
          placeholder="Email address"
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <span className='inputLabel'>Phone:</span>
        <Input
          className='floatLeft inputWidthMedium marginBottom_10'
          placeholder="Phone number"
          type="tel"
          id="phone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <span className='inputLabel'>Password:</span>
        <Input
          className='floatLeft inputWidthMedium marginBottom_10'
          placeholder="Password"
          type="password"
          id="pswd_1"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <span className='inputLabel'>Confirm Pswd:</span>
        <Input
          className='floatLeft inputWidthMedium marginBottom_10'
          placeholder="Password Confirmation"
          type="password"
          id="pswd_2"
          value={passwordConfirm}
          onChange={(e) => setPasswordConfirm(e.target.value)}
        />
        <br />
        <span className='inputLabel' style={{ clear: "both", display: "block" }}>User Role:</span>
        <Dropdown
          className='floatLeft inputWidthMedium marginBottom_10'
          placeholder="Select Role"
          fluid
          selection
          options={roleOptions}
          value={role}
          onChange={(e, { value }) => setRole(value)}
        />
        <br />
        <Button className="floatLeft" style={{ clear: "both", marginTop: "10px" }} type="submit">Register</Button>

      </form>
      <div className="floatLeft marginTop_10" style={{ width: '100%' }}>
        {userProfile.error && <Message negative>Error: {userProfile.error}</Message>}
        {userProfile.loading && <Message>Loading...</Message>}
        {formError && <Message negative>{formError}</Message>}
      </div>

    </div>
  );
}

export default RegistrationForm;
